module.exports = __webpack_public_path__ + "static/media/sports_28.31204f26.jpg";